<template>
  <div class="custom-section-container1">
    <section id="custom-section-pricing" class="custom-section-pricing">
      <div class="custom-section-pricing__container">
        <div class="custom-section-pricing__header">
          <p class="section-subtitle">Transparent prices</p>
          <h2 class="section-title">Choose the plan that fits your shop</h2>
          <p class="custom-section-pricing__description">
            From single-person shops to full-scale factories. All plans include
            the core features you need—pay for the power and scale that matches
            your production.
          </p>
        </div>
        <div class="custom-section-pricing__grid">
          <article class="custom-section-pricing__card">
            <div class="custom-section-pricing__card-header">
              <div
                class="custom-section-pricing__icon-wrapper--starter custom-section-pricing__icon-wrapper"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"
                    ></path>
                    <path
                      d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
                    ></path>
                  </g>
                </svg>
              </div>
              <h3 class="custom-section-pricing__plan-name">Starter</h3>
              <p class="custom-section-pricing__plan-subtitle">
                Perfect for small workshops
              </p>
            </div>
            <div class="custom-section-pricing__card-body">
              <div class="custom-section-pricing__price-wrapper">
                <p class="custom-section-pricing__price-label">From</p>
                <p class="custom-section-pricing__price">On request</p>
              </div>
              <ul class="custom-section-pricing__features">
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>One-click to CNC</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Parametric cabinet design</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Auto cut-lists &amp; labels</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>CNC toolpath generation</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>1 workstation license</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Email support</span>
                </li>
              </ul>
            </div>
            <div class="custom-section-pricing__card-footer">
              <button class="btn btn-outline">Schedule a demo</button>
            </div>
          </article>
          <article
            class="custom-section-pricing__card--featured custom-section-pricing__card"
          >
            <div class="custom-section-pricing__badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span>Most popular</span>
            </div>
            <div class="custom-section-pricing__card-header">
              <div
                class="custom-section-pricing__icon-wrapper custom-section-pricing__icon-wrapper--pro"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"
                    ></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 class="custom-section-pricing__plan-name">Pro</h3>
              <p class="custom-section-pricing__plan-subtitle">
                For growing production teams
              </p>
            </div>
            <div class="custom-section-pricing__card-body">
              <div class="custom-section-pricing__price-wrapper">
                <p class="custom-section-pricing__price-label">From</p>
                <p class="custom-section-pricing__price">On request</p>
              </div>
              <ul class="custom-section-pricing__features">
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>
                    <span class="custom-section-text18">
                      Everything in Starter, plus:
                    </span>
                  </span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Batch production automation</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Nesting software integration</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Panel saw &amp; edgebander connect</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Up to 5 workstation licenses</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Priority phone support</span>
                </li>
              </ul>
            </div>
            <div class="custom-section-pricing__card-footer">
              <button class="btn btn-primary">Schedule a demo</button>
            </div>
          </article>
          <article class="custom-section-pricing__card">
            <div class="custom-section-pricing__card-header">
              <div
                class="custom-section-pricing__icon-wrapper--factory custom-section-pricing__icon-wrapper"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 class="custom-section-pricing__plan-name">Factory</h3>
              <p class="custom-section-pricing__plan-subtitle">
                Full-scale production automation
              </p>
            </div>
            <div class="custom-section-pricing__card-body">
              <div class="custom-section-pricing__price-wrapper">
                <p class="custom-section-pricing__price-label">From</p>
                <p class="custom-section-pricing__price">On request</p>
              </div>
              <ul class="custom-section-pricing__features">
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>
                    <span class="custom-section-text25">
                      Everything in Pro, plus:
                    </span>
                  </span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>REST API access</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Configurator integration</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Plate warehouse connection</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>ERP integration support</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Unlimited workstations</span>
                </li>
                <li class="custom-section-pricing__feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Dedicated account manager</span>
                </li>
              </ul>
            </div>
            <div class="custom-section-pricing__card-footer">
              <button class="btn btn-outline">Schedule a demo</button>
            </div>
          </article>
        </div>
        <div class="custom-section-pricing__comparison">
          <h3 class="custom-section-pricing__comparison-title">
            Detailed comparison
          </h3>
          <div class="custom-section-pricing__table-wrapper">
            <table class="custom-section-pricing__table">
              <thead>
                <tr>
                  <th class="custom-section-pricing__table-header">
                    <span>Feature</span>
                  </th>
                  <th class="custom-section-pricing__table-header">
                    <span>Starter</span>
                  </th>
                  <th
                    class="custom-section-pricing__table-header--featured custom-section-pricing__table-header"
                  >
                    <span>Pro</span>
                  </th>
                  <th class="custom-section-pricing__table-header">
                    <span>Factory</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Parametric cabinet design</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>One-click to CNC toolpaths</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Auto cut-lists &amp; labels</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Crash checks &amp; collision detection</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Batch production automation</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Nesting software integration</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Panel saw &amp; edgebander connect</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Hardware libraries</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>REST API access</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Configurator &amp; ERP integration</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Plate warehouse connection</span>
                  </td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--empty custom-section-pricing__table-cell"
                  ></td>
                  <td
                    class="custom-section-pricing__table-cell--check custom-section-pricing__table-cell"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Workstation licenses</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>1</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>Up to 5</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>Unlimited</span>
                  </td>
                </tr>
                <tr class="custom-section-pricing__table-row">
                  <td class="custom-section-pricing__table-cell">
                    <span>Support level</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>Email</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>Priority phone</span>
                  </td>
                  <td class="custom-section-pricing__table-cell">
                    <span>Dedicated manager</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="custom-section-pricing__cta">
          <div class="custom-section-pricing__cta-content">
            <h3 class="custom-section-pricing__cta-title">
              Not sure which plan fits your shop?
            </h3>
            <p class="custom-section-pricing__cta-text">
              Book a 30-minute demo and we&apos;ll help you choose the right
              solution for your production workflow.
            </p>
            <button class="btn btn-lg btn-primary">Plan een demo</button>
          </div>
          <div class="custom-section-pricing__cta-image">
            <img
              alt="CNC machine workshop"
              src="https://images.pexels.com/photos/9242202/pexels-photo-9242202.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CustomSection',
  props: {},
  mounted() {
    // Vue 3 migration/security: replace injected script with lifecycle logic.
    const cleanupHandlers = []
    const addListener = (target, event, handler, options) => {
      if (!target) {
        return
      }
      target.addEventListener(event, handler, options)
      cleanupHandlers.push(() => target.removeEventListener(event, handler))
    }

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }

    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0)'
          }, index * 100)
          cardObserver.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const cards = document.querySelectorAll('.custom-section-pricing__card')
    cards.forEach((card) => {
      card.style.opacity = '0'
      card.style.transform = 'translateY(2rem)'
      card.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out'
      cardObserver.observe(card)
    })

    const tableObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateX(0)'
          }, index * 50)
          tableObserver.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const tableRows = document.querySelectorAll(
      '.custom-section-pricing__table-row'
    )
    tableRows.forEach((row) => {
      row.style.opacity = '0'
      row.style.transform = 'translateX(-1rem)'
      row.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out'
      tableObserver.observe(row)
    })

    const handleDemoClick = () => {
      const contactSection =
        document.getElementById('contact') || document.getElementById('demo')
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
    const demoButtons = document.querySelectorAll('.custom-section-pricing .btn')
    demoButtons.forEach((button) =>
      addListener(button, 'click', handleDemoClick)
    )

    this._cleanupCustomSection = () => {
      cleanupHandlers.forEach((handler) => handler())
      cleanupHandlers.length = 0
      cardObserver.disconnect()
      tableObserver.disconnect()
    }
  },
  beforeUnmount() {
    if (this._cleanupCustomSection) {
      this._cleanupCustomSection()
    }
  },
}
</script>

<style scoped>
.custom-section-container1 {
  display: contents;
}
 
.custom-section-container2 {
  display: none;
}
 
.custom-section-container3 {
  display: contents;
}
 
.custom-section-text18 {
  font-weight: 700;
}
 
.custom-section-text25 {
  font-weight: 700;
}
</style>
